const confirmationCodeES = {
	title: "Confirmar Cuenta",
	subtitle: "Ingresa el código enviado a tu correo y tu cuenta queda lista.",
	hint: "¿No lo encuentras? Revisa tu carpeta de spam — llega en menos de un minuto.",
	email: "Correo electrónico",
	code: "Código de Confirmación",
	button: "Confirmar",
	loading: "Confirmando...",
	resendCode: "Reenviar Código",
	sendingCode: "Enviando...",
	backToLogin: "Volver a Iniciar Sesión",
	invalidCode: "Ese código no es válido o ya expiró. Revisa tu correo e inténtalo de nuevo.",
};
export default confirmationCodeES;
